<template>
  <div>
    <v-btn color="primary" dark x-small class="trigger-btn" @click="toggleMenu">
      {{ btnText }}
      <v-icon size="14" right dark> fas fa-caret-down </v-icon>
    </v-btn>

    <v-menu
      v-model="menu"
      :position-x="x"
      :position-y="y"
      absolute
      bottom
      offset-x
      :close-on-click="false"
      :close-on-content-click="false"
    >
      <v-list>
        <v-list-item class="py-0 px-3" style="min-height: 0;">
          <v-list-item-title class="text-right">
            <v-icon size="14" @click="menu = !menu" class="icon-close"
              >fas fa-times</v-icon
            >
          </v-list-item-title>
        </v-list-item>

        <v-list-item class="pa-0">
          <v-list-item-title>
            <v-radio-group v-model="radios" class="mt-2">
              <v-radio class="px-3 pb-3" value="average">
                <template v-slot:label>
                  <div>
                    <strong>Average Low</strong>
                    <span class="ml-1 grey--text">({{ lowText }})</span>
                  </div>
                </template>
              </v-radio>
              <v-radio class="px-3" value="specified">
                <template v-slot:label>
                  <div><strong>Specified Low</strong></div>
                </template>
              </v-radio>
            </v-radio-group>
            <div class="below-specified-low pb-3">
              <div class="pull-left grey--text below-specified-low-text">
                Below
              </div>
              <div class="pull-left">
                <v-text-field
                  v-model="specifiedLowerBound"
                  :disabled="radios !== 'specified'"
                  hide-details
                  single-line
                  type="number"
                  min="1"
                  max="100"
                  step="1"
                  title=""
                  :rules="[rules.range]"
                  class="ml-4 ma-0 pa-0 text-grey hyp-bounds-input"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                />
              </div>
              <div class="clearfix"></div>
            </div>
            <v-btn
              color="success"
              dark
              small
              class="ml-3 mb-2 set-trigger-btn"
              @click="handleBoundChange"
              >Set Trigger</v-btn
            >
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import lodashGet from "lodash/get";

const EMITTED_ACTIONS = {
  CHANGE: "change",
};

export default {
  name: "PulsePopup",
  props: {
    item: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
    },
  },
  data() {
    return {
      menu: false,
      x: 0,
      y: 0,
      radios: "average",
      specifiedLowerBound: this.item.lowerBound,
      rules: {
        range: (value) =>
          (parseInt(value) <= 100 && parseInt(value) > 0) ||
          "Value must be between 1 and 100",
      },
    };
  },
  mounted() {
    if (!this.useLowestDynamicBound) {
      this.radios = "specified";
    }
  },
  computed: {
    useLowestDynamicBound() {
      return this.item.useLowestDynamicBound;
    },
    lowText() {
      return this.item.lowerBoundOriginal;
    },
    btnText() {
      if (!this.useLowestDynamicBound) {
        return `Below ${this.item.lowerBound}`;
      }
      return `Below Avg`;
    },
  },
  methods: {
    toggleMenu(e) {
      e.preventDefault();
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.menu = !this.menu;
      });
    },
    handleBoundChange() {
      this.menu = false;
      let lowerBound = this.item.lowerBoundOriginal;
      let useLowestDynamicBound = true;
      if (this.radios === "specified") {
        lowerBound = this.specifiedLowerBound;
        useLowestDynamicBound = false;
      }
      this.$emit(
        EMITTED_ACTIONS.CHANGE,
        this.index,
        lowerBound,
        useLowestDynamicBound
      );
    },
  },
};
</script>

<style>
.text-grey input {
  padding: 0;
  color: grey !important;
}
</style>

<style scoped>
.hyp-bounds-input {
  width: 45px;
  font-size: 14px;
  position: relative;
  top: -3px;
}
.below-specified-low {
  margin-left: 50px;
  position: relative;
  top: -10px;
}
.below-specified-low-text {
  font-size: 14px;
}
.trigger-btn {
  min-width: 102px !important;
}
.set-trigger-btn {
  margin-left: 45px !important;
}
.icon-close {
  cursor: pointer;
}
</style>
